import axios from "../axiosInstance";

interface DeleteResponse {
  message: string;
}

/**
 * Delete (archive) a library module
 * @param id Module ID
 * @param permanent If true, permanently delete instead of archiving
 */
export const deleteLibraryModule = async (
  id: number,
  permanent: boolean = false
): Promise<DeleteResponse> => {
  const url = permanent
    ? `/api/learning-center/module-library/${id}?permanent=true`
    : `/api/learning-center/module-library/${id}`;

  const response = await axios.delete<DeleteResponse>(url);
  return response.data;
};

export default deleteLibraryModule;
